<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['NOME', 'DOCUMENTO', 'EMAIL']"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNewPerson"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.document ? formatDocument(obj.document) : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.email ? obj.email : ''" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'

import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import PersonSearchScreen from '../search/search.vue'

export default {
  name: 'PersonList',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        PersonRepository.Search(this.createRequestParam(), this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      } else {
        PersonRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    createRequestParam () {
      let listParam = []
      if (this.filters.nome) {
        listParam.push('nome=' + this.filters.nome.toString())
        listParam.push('document=' + this.filters.nome.toString())
      }
      return listParam.join('&')
    },
    onNewPerson () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: PersonSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    },
    formatDocument (doc) {
      return Tools.formatCpfCnpj(doc, Tools.checkDocumentType(doc))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/person/components/list/personList.vue